import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';

const contentPrimary = '#001464';
const contentSecondary = '#001443';
const blue300 = '#B4D4F8';

const ExcessDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding: 8px 0px 0px 0px;
`;
const ExcessDetailTitle = styled.label`
  color: ${contentPrimary};
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 165%;
  align-self: stretch;
`;

const ExcessList = styled.ul`
  width: 100%;
`;

const ExcessItem = styled.li`
  color: ${contentSecondary};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 170%;
`;

const ExcessItemContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  @media only screen and (max-width: 600px) {
    gap: 40px;
  }
`;

const ExcessDetailItemContainer = styled.div`
  display: flex;
  padding: 0px 0px 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid ${blue300};
`;
const ExcessReferToPDS = styled.label`
  color: #001443;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 170%;
`;

/**
 * Function for rendering product details.
 *
 * @param {object} props - the properties object
 * @return {JSX.Element} the rendered product details component
 */

const ExcessDetails = (props) => {
    const { title, details } = props;
    return (
        <ExcessDetailContainer>
            <ExcessDetailItemContainer>
                <ExcessDetailTitle>{title}</ExcessDetailTitle>
                {details.length === 0 ? <ExcessReferToPDS>Refer to PDS</ExcessReferToPDS>
                    : (
                        <ExcessList>
                            {details.map((detail, index) => (
                                <ExcessItem key={`excess-item-${index}`}>
                                    <ExcessItemContainer>
                                        <label>{detail.key}</label>
                                        {detail.value && <label>{detail.value}</label>}
                                    </ExcessItemContainer>
                                </ExcessItem>
                            ))}
                        </ExcessList>
                    )}
            </ExcessDetailItemContainer>
        </ExcessDetailContainer>
    );
};

ExcessDetails.propTypes = {
    title: PropTypes.string.isRequired,
    details: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            value: PropTypes.string
        })
    ).isRequired,
    showBottom: PropTypes.bool
};

export { ExcessDetails };
